export const KN_BR_CONTEXT_CART_FEATURE = 'kn-br-cart-context';

export interface KnBrCartContextState {
  cartContext?: string;
}

export interface StateWithCartContext {
  [KN_BR_CONTEXT_CART_FEATURE]: KnBrCartContextState;
}
